import { ICheckoutState, IProspect } from '../../../../interfaces';
import { CREDIT_CARD } from '../../../utils/constants';
import { getDefaultPlanCode } from '../../../utils/getDefaultPlanCode';

export const defaultProspect: IProspect = {
  planCode: getDefaultPlanCode(),
  email: '',
  password: '',
  isEmailUnique: true,
  firstName: '',
  lastName: '',
  shipZip: '',
  shipCountry: 'US',
  shipState: '',
  postalCode: '',
  promoCode: '',
  discount: '',
  total: 0,
};

export const createCheckoutState = (): ICheckoutState => ({
  ...defaultProspect,
  billingMethod: CREDIT_CARD,
  hCaptchaToken: null,
  recurlyError: null,
  formError: null,
  shipZipError: null,
  loading: false,
  acceptedTerms: false,
});
